import { cn } from '@/lib/utils'

const VARIANTS = {
  full: { light: '/brand/maktab-logo-full.png', dark: '/brand/maktab-logo-full-reversed.png' },
  header: {
    light: '/brand/maktab-header-horizontal.png',
    dark: '/brand/maktab-header-horizontal-reversed.png',
  },
  mark: { light: '/brand/maktab-mark.png', dark: '/brand/maktab-mark-reversed.png' },
  wordmark: { light: '/brand/maktab-wordmark.png', dark: '/brand/maktab-wordmark-white.png' },
} as const

export type BrandLogoVariant = keyof typeof VARIANTS

interface BrandLogoProps {
  variant?: BrandLogoVariant
  className?: string
}

/** Maktab logo that swaps to the reversed artwork in dark mode. Size it with `className` (e.g. `h-8`). */
export function BrandLogo({ variant = 'header', className }: BrandLogoProps) {
  const { light, dark } = VARIANTS[variant]
  return (
    <>
      <img
        src={light}
        alt='Maktab'
        className={cn('w-auto object-contain dark:hidden', className)}
      />
      <img
        src={dark}
        alt=''
        aria-hidden='true'
        className={cn('hidden w-auto object-contain dark:block', className)}
      />
    </>
  )
}
